<template>
  <div :class="[
        {
          'adv-cart-product-list': true,
          'is-minicart': miniCart,
          'is-cart': !miniCart
        }
      ]"
  >
    <adv-cart-product-row
      v-for="(cartProduct, index) in cartProductContents"
      :hasDuplicateSignature="hasDuplicateSignature(cartProduct)"
      :key="index"
      :mini-cart="miniCart"
      :read-only="readOnly"
      :disable-product-links="disableProductLinks"
      :cart-product="cartProduct"></adv-cart-product-row>
  </div>
</template>

<script>
import store from '../../vue/store'
import AdvCartProductRow from './AdvCartProductRow'

export default {
  name: 'AdvCartProductList',
  components: {
    AdvCartProductRow
  },
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    cartProductContents () {
      return store.getters.cartContents
    },
    getSelectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: 0
      })
    },
    hasDuplicateSignature (cartProduct) {
      const groups = cartProduct.options?.cartProductCustomizations?.groups;
      if (!Array.isArray(groups)) return false;

      for (const group of groups) {
        const rawValue = group?.items?.[0]?.value;
        const normalizedValue = rawValue?.normalize('NFC');
        if (
          normalizedValue !== 'Με γενική αφιέρωση'.normalize('NFC') &&
          group.name?.el === "Ενυπόγραφο" &&
          (cartProduct.quantity || 0) > 1
        ) {
          return true;
        }
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.adv-cart-product-list {
  width: 100%;
  &.is-cart {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    @media screen and (min-width:1200px) and (max-width:1399px){
      grid-template-columns: repeat(4, 1fr)
    }
    @media screen and (max-width:1199px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;
    }
    @media screen and (max-width:767px) {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }
  &.is-minicart {
    display: grid;
    gap: 10px;
  }
}
</style>
